import { FastApiAxiosInstance } from 'common/service/axiosInstances';
import {
  CommonListParams,
  CommonListResponse,
  FastApiRechargeRecord,
  FastApiWithdrawRecord,
  AssetTradeRecord,
  RBAC_TableQuery,
  TaskIncomeRecord,
  TaskExpendRecord,
  TransactionType,
  WithdrawDetail,
} from 'common/types';

const order = {
  //充值 或 转账
  rechargeOrder(params: {
    amount: string;
    frontUrl: string;
    receiverUserKey?: string;
    serviceRate?: string;
    platformTradeId?: string;
    type: TransactionType;
  }) {
    return FastApiAxiosInstance.post<{ payUrl: string }>('/api/v1/order/balance/create', params);
  },
  //申请提现
  applyWithdraw(params: { amount: string; withdrawChannel: string }) {
    return FastApiAxiosInstance.post<{ payUrl: string }>('/api/v1/order/withdrawTax/create', params);
  },
  //获取资产交易列表
  getArtAssetDealList: (params: CommonListParams) => {
    return FastApiAxiosInstance.get<CommonListResponse<AssetTradeRecord>>('/api/v1/order/asset/list', {
      params,
    });
  },
  //获取充值列表
  getRechargeList: (params: CommonListParams) => {
    return FastApiAxiosInstance.get<CommonListResponse<FastApiRechargeRecord>>('/api/v1/order/balance/rechargeList', {
      params,
    });
  },
  //获取提现列表
  getWithdrawList: (params: CommonListParams) => {
    return FastApiAxiosInstance.get<CommonListResponse<FastApiWithdrawRecord>>('/api/v1/order/balance/withdrawList', {
      params,
    });
  },
  getWithdrawDetailList: (params: { amount: string }) => {
    return FastApiAxiosInstance.get<CommonListResponse<WithdrawDetail>>('/api/v1/order/balance/withdrawTaskList', {
      params,
    });
  },

  // 获取任务交易收入记录，路径待替换为 order
  getTaskIncomeRecordList(params: RBAC_TableQuery) {
    return FastApiAxiosInstance.get<{ items: TaskIncomeRecord[]; page: number; size: number; total: number }>(
      '/api/v1/payment/getIncomeTaskOrders',
      {
        params: params,
      },
    );
  },
  // 获取任务交易支出记录，路径待替换为 order
  getTaskExpendRecordList(params: RBAC_TableQuery) {
    return FastApiAxiosInstance.get<{ items: TaskExpendRecord[]; page: number; size: number; total: number }>(
      '/api/v1/payment/getConsumeTaskOrders',
      {
        params,
      },
    );
  },
  //提现前校验
  validateBeforeWithdraw() {
    return FastApiAxiosInstance.post<{ total: number; items: { url: string; name: string }[] }>(
      '/api/v1/order/withdraw/valid',
    );
  },
  //用户签约
  userSign: () => {
    return FastApiAxiosInstance.post<null>('/api/v1/user/protocol/sign');
  },
  // 用户签约提现协议查询
  getUserSignedProtocol: () => {
    return FastApiAxiosInstance.get('/api/v1/user/withdraw/agreements/list');
  },
};

export default order;
